import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { UserManagementService } from '../../service/user-management.service';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { OrderService } from '../../service/order.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  roleDDL: any = [];
  // selecteRole: string;
  selecteRoles = [];
  customerMultiDDL: any[];
  selectedMultiDDL: number[] = [];
  customerSingleDDL: any[];
  selectedSingleDDL: number[] = [];
  //suppliersOptions: any[] = [];
  //selectedSupplier: any;
  showSuppliers: boolean = false;

  suppliers: any = [];
  selectedSuppliers: any = [];  //any[] = [];
  filteredSuppliers: any = [];  //any[] = [];

  customersOptions: any[] = [];
  selectedCustomer: any;
  showCustomers: boolean = false;
  
  user = {
    Id: '',
    UserName: '',
    PhoneNumber: '',
    FirstName: '',
    LastName: '',
    // selecteRole: '',
    selecteRoles: [],
    selectedDDL: [],
    OtpTypeId: 1,
    CustomerId: null,
    SupplierId: null
  };
  intDDl = {
    value: null,
    label: 'בחירה'
  }
  message: string = '';
  isValid: number = 0;
  msgs: Message[] = [];

  constructor(public dataService: UserManagementService, private orderService: OrderService, public router: Router) {
    this.dataService.getRoleDDL().subscribe((res: any) => {
      this.roleDDL = res;
      // this.selecteRole = this.roleDDL[0].value;
      this.selecteRoles = []; // this.roleDDL.value;
    });

    
  }

  searchSuppliers(event) {
    let query = event.query;
    this.filteredSuppliers = this.filterSuppliers(query, this.suppliers);
  }

  ngOnInit() {

      this.fillCustomers();
  }

  rolesChanged() {
    this.validateShowCustomersAndSuppliers();
  }

  validateShowCustomersAndSuppliers() {
    if (!this.selecteRoles || this.selecteRoles.length == 0) {
      this.showCustomers = false;
      this.showSuppliers = false;
      //this.selectedSupplier = null;
      this.selectedSuppliers = null;
      this.selectedCustomer = null;
      return;
    }

    let customerRole = this.selecteRoles.find(s=> (s == 'Customer'));
    let supplierRole = this.selecteRoles.find(s=> (s == 'Supplier'));

    if (customerRole && supplierRole) {
      this.showCustomers = false;
      this.showSuppliers = false;
      //this.selectedSupplier = null;
      this.selectedSuppliers = null;
      this.selectedCustomer = null;
      this.showMessage('error', '', 'לא ניתן לבחור שתי הרשאות ביחד - ספק וגם לקוח');
    } else if (customerRole) {
      this.showCustomers = true;
      this.showSuppliers = false;
      //this.selectedSupplier = null;
      this.selectedSuppliers = null;
    } else if (supplierRole) {
      this.showCustomers = true;
      this.showSuppliers = true;
    } else {
      this.showCustomers = false;
      this.showSuppliers = false;
      //this.selectedSupplier = null;
      this.selectedSuppliers = null;
      this.selectedCustomer = null;
    }

  }

  

  fillCustomers() {
    //this.selectedSupplier = null;
    this.selectedSuppliers = null;
    this.dataService.getCustomers().subscribe((result: any) => {
      this.customersOptions = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת לקוחות ');
    });
  }

  fillSuppliers() {
    //this.selectedSupplier = null;
    this.selectedSuppliers = null;
    if (!this.selectedCustomer) {
      //this.suppliersOptions = null;
      this.suppliers = null;
      return;
    }
    this.orderService.GetCustomerSuppliersByCustomer(this.selectedCustomer.CustomerId).subscribe((result: any) => {
      //this.suppliersOptions = result;
      this.suppliers = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת ספקים ');
    });
  }

  onSubmit(f: NgForm) {
    if (f.valid) {


      let supplierRole = this.selecteRoles.find(s=> (s == 'Supplier'));
      let customerRole = this.selecteRoles.find(s=> (s == 'Customer'));
      let customer1Role = this.selecteRoles.find(s=> (s == 'CustomerConfirm'));
      let customer2Role = this.selecteRoles.find(s=> (s == 'CustomerPaymentConfirm'));
      let customer3Role = this.selecteRoles.find(s=> (s == 'CustomerPaymentSetDate'));
      let customer4Role = this.selecteRoles.find(s=> (s == 'CustomerRedirectTreatment'));
      let customer5Role = this.selecteRoles.find(s=> (s == 'CustomerPaymentConfirmOwnOnly'));

      if (customerRole && supplierRole) {
        this.showMessage('error', '', 'לא ניתן לבחור שתי הרשאות ביחד - ספק וגם לקוח');
        return;
      }
      if (customerRole && (!this.selectedCustomer)) {
        this.showMessage('error', '', 'עבור משתמש עם הרשאת לקוח חובה לבחור לקוח');
        return;
      }
      if (!customerRole && (customer1Role || customer2Role || customer3Role || customer4Role || customer5Role)) {
        this.showMessage('error', '', 'בבחירת אחת או יותר של הרשאות נוספות של לקוח חובה לבחור הרשאה בסיסית של לקוח');
        return;
      }
      if (supplierRole && (customer1Role || customer2Role || customer3Role || customer4Role || customer5Role)) {
        this.showMessage('error', '', 'לא ניתן לבחור הרשאות שסומנו ביחד');
        return;
      }
      //if (supplierRole && (!this.selectedCustomer || !this.selectedSupplier) ) {
      if (supplierRole && (!this.selectedCustomer || !this.selectedSuppliers) ) {
        this.showMessage('error', '', 'עבור משתמש עם הרשאת ספק חובה לבחור ספק וגם לקוח');
        return;
      }

      this.isValid = 1;
      this.user.UserName = f.value.UserName;
      this.user.PhoneNumber = f.value.PhoneNumber;
      this.user.FirstName = f.value.FirstName;
      this.user.LastName = f.value.LastName;
      this.user.OtpTypeId = f.value.OtpTypeId;
      // this.user.selecteRole = f.value.selecteRole;
      this.user.selecteRoles = f.value.selecteRoles;
      if (f.value.selectedMultiDDL !== undefined) {
        this.user.selectedDDL = this.selectedMultiDDL;
      }
      else if (f.value.selectedSingleDDL !== undefined) {
        this.user.selectedDDL.push(this.selectedSingleDDL);
      }
      if (customerRole) {
        this.user.CustomerId = this.selectedCustomer.CustomerId;
        this.user.SupplierId = null;
      }
      if (supplierRole) {
        this.user.CustomerId = this.selectedCustomer.CustomerId;
        //this.user.SupplierId = this.selectedSupplier.Id;
        this.user.SupplierId = this.selectedSuppliers.Id;
      }

      this.dataService.insertUser(this.user).subscribe(res => {
        this.message = res.toString();
        if (this.message === '0') {
          this.showSuccess();
          setTimeout(() => {
            location.href = 'create-user';
          }, 1500);
        }
        else if (this.message === '1') {
          this.showErrorSpecific();
        }
        else {
          this.showError();
        }
      });
    }
  }

  
  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }
  
  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: 'נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בשמירה' });
  }

  showErrorSpecific() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שם משתמש כבר בשימוש' });
  }

  filterSuppliers(query, suppliers: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < suppliers.length; i++) {
      let supplier = suppliers[i];
      if (supplier.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0 || supplier.EMail.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(supplier);
      }
    }
    return filtered;
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/user-management/create-user/create-user.component.ts